import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { defineMessages, useIntl } from 'react-intl';
import { parse, stringify } from '../../utils/UrlUtil';

const consumptionTypesMsg = defineMessages({
  all: { id: 'consumption.consumption_type.all', defaultMessage: 'All' },
  assessment: { id: 'consumption.consumption_type.assessment', defaultMessage: 'Assessment' },
  multiAssessment: {
    id: 'consumption.consumption_type.multi-assessment',
    defaultMessage: 'Assessments',
  },
  survey: { id: 'consumption.consumption_type.survey', defaultMessage: 'Survey' },
  multiSurvey: {
    id: 'consumption.consumption_type.multi-survey',
    defaultMessage: 'Surveys',
  },
});

const messages = defineMessages({
  startDate: { id: 'placeholder.startWith', defaultMessage: 'Start date' },
  endDate: { id: 'placeholder.endWith', defaultMessage: 'End date' },
});

const ConsumptionTableHeader = () => {
  const history = useHistory();
  const location = { history };

  const { formatMessage } = useIntl();

  const params = parse(location.search);

  const DEFAULT_FILTER_STATE = {
    type: 'ALL',
    from: undefined,
    to: undefined,
    ...params.filter,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER_STATE);

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = (newFilter) => {
    // build the filter
    const updatedFilter = { ...newFilter };

    // handle edge case for type = ALL.
    if (updatedFilter.type === 'ALL') {
      updatedFilter.type = undefined;
    }

    // handle date filter
    if (updatedFilter.from) {
      const fromDate = moment(updatedFilter.from).format('YYYY-MM-DD');
      updatedFilter.from = fromDate;
    }

    if (updatedFilter.to) {
      const toDate = moment(updatedFilter.to).format('YYYY-MM-DD');
      updatedFilter.to = toDate;
    }

    const search = stringify({
      ...params,
      filter: updatedFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  const onConsumptionTypeChange = (event) => {
    const newFilter = {
      ...filter,
      type: event.value,
    };

    setFilter(newFilter);

    onQueryVariableChange(newFilter);
  };

  const onDateFilterChange = (event, dateFilter) => {
    const newFilter = {
      ...filter,
      [dateFilter]: event.value,
    };

    setFilter(newFilter);

    onQueryVariableChange(newFilter);
  };

  const start = formatMessage(messages.startDate);
  const end = formatMessage(messages.endDate);

  const fromFilter = filter.from ? new Date(filter.from) : null;
  const toFilter = filter.to ? new Date(filter.to) : null;

  const consumptionTypeOptions = [
    { label: formatMessage(consumptionTypesMsg.all), value: 'ALL' },
    { label: formatMessage(consumptionTypesMsg.assessment), value: 'ASSESSMENT' },
    { label: formatMessage(consumptionTypesMsg.multiAssessment), value: 'MULTI_ASSESSMENT' },
    { label: formatMessage(consumptionTypesMsg.survey), value: 'SURVEY' },
    { label: formatMessage(consumptionTypesMsg.multiSurvey), value: 'MULTI_SURVEY' },
  ];

  return (
    <>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <Calendar
            value={fromFilter}
            onChange={event => onDateFilterChange(event, 'from')}
            readOnlyInput
            showIcon
            showButtonBar
            dateFormat="yy-M-dd"
            placeholder={start}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <Calendar
            value={toFilter}
            onChange={event => onDateFilterChange(event, 'to')}
            dateFormat="yy-M-dd"
            readOnlyInput
            showIcon
            showButtonBar
            placeholder={end}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <div>
            <Dropdown value={filter.type} options={consumptionTypeOptions} onChange={onConsumptionTypeChange} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsumptionTableHeader;
